import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import timeUtils from '@/utils/time.js';
import FlipUnitContainer from './Count/FlipUnitCountainer';
export default {
  // mounted () {
  //   setTimeout( () => {
  //     this.hide()
  //   }, 3000 )
  //   setTimeout( () => {
  //     this.show()
  //   }, 5000 )
  // },
  components: {
    FlipUnitContainer: FlipUnitContainer
  },
  data: function data() {
    return {
      days: 0,
      daysShuffle: true,
      hours: 0,
      hoursShuffle: true,
      minutes: 0,
      minutesShuffle: true,
      seconds: 0,
      secondsShuffle: true
    };
  },
  props: {
    onSaleTime: Number,
    now: Number,
    mode: {
      type: String,
      default: 'normal'
    }
  },
  computed: {
    onSaleTimeInfo: function onSaleTimeInfo() {
      var onSaleTime = this.onSaleTime;
      var _timeUtils$formatOnSa = timeUtils.formatOnSaleTime(onSaleTime),
        onSaleTimeInfo = _timeUtils$formatOnSa.onSaleTimeInfo;
      return onSaleTimeInfo;
    },
    leftTimeInfo: function leftTimeInfo() {
      var now = this.now,
        onSaleTime = this.onSaleTime;
      var leftTimeInfo = timeUtils.fomatRemainText(now, onSaleTime);
      return leftTimeInfo;
    }
  },
  watch: {
    now: function now() {
      this.updateTime();
    }
  },
  created: function created() {
    var _this$getNowTime = this.getNowTime(),
      days = _this$getNowTime.days,
      hours = _this$getNowTime.hours,
      minutes = _this$getNowTime.minutes,
      seconds = _this$getNowTime.seconds;
    this.days = days;
    this.hours = hours;
    this.minutes = minutes;
    this.seconds = seconds;
  },
  methods: {
    getNowTime: function getNowTime() {
      var now = this.now,
        onSaleTime = this.onSaleTime;
      var leftTime = onSaleTime - now;
      var leftDays = timeUtils.getLeftDays(leftTime);
      var leftHours = timeUtils.getLeftHours(leftTime);
      var leftMinutes = timeUtils.getLeftMinutes(leftTime);
      var leftSeconds = timeUtils.getLeftSeconds(leftTime);
      return {
        days: leftDays,
        hours: leftHours,
        minutes: leftMinutes,
        seconds: leftSeconds
      };
    },
    updateTime: function updateTime() {
      var _this$getNowTime2 = this.getNowTime(),
        days = _this$getNowTime2.days,
        hours = _this$getNowTime2.hours,
        minutes = _this$getNowTime2.minutes,
        seconds = _this$getNowTime2.seconds;
      // on days change, update days and shuffle state
      if (days !== this.days) {
        this.days = days;
        this.daysShuffle = !this.daysShuffle;
      }
      // on hour chanage, update hours and shuffle state
      if (hours !== this.hours) {
        this.hours = hours;
        this.hoursShuffle = !this.hoursShuffle;
      }
      // on minute chanage, update minutes and shuffle state
      if (minutes !== this.minutes) {
        this.minutes = minutes;
        this.minutesShuffle = !this.minutesShuffle;
      }
      // on second chanage, update seconds and shuffle state
      if (seconds !== this.seconds) {
        this.seconds = seconds;
        this.secondsShuffle = !this.secondsShuffle;
      }
    },
    hide: function hide() {
      var bomb = document.getElementById('bomb-component');
      bomb.animate([{
        top: 0
      }, {
        top: '150%'
      }], {
        fill: 'forwards',
        duration: 800
      });
    },
    show: function show() {
      var bomb = document.getElementById('bomb-component');
      bomb.animate([{
        top: '150%'
      }, {
        top: 0
      }], {
        fill: 'forwards',
        duration: 800
      });
    }
  }
};